import React from 'react';

import { Sheet, SheetBody, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';

/**
 * Presentational Radix Sheet wrapper used by the modern onboarding container.
 *
 * Wraps the design-system `Sheet` primitive so the container stays focused on
 * data flow. Keep this component free of side-effects.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {(open: boolean) => void} props.onOpenChange
 * @param {string} [props.title]
 * @param {React.ReactNode} props.children
 */
export function OnboardingSheet({ open, onOpenChange, title, children }) {
  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
    >
      <SheetContent
        side="right"
        size="sm"
        aria-label={title || 'Onboarding'}
      >
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        <SheetBody>{children}</SheetBody>
      </SheetContent>
    </Sheet>
  );
}
